<app-stats-card *ngFor="let statsCard of statsCards" [statsCard]="statsCard"></app-stats-card>
